module.exports = __webpack_public_path__ + "static/media/s13.1473fd62.ogg";